import styled from 'styled-components'
import { Spin as SpinAnt } from 'antd'

export const SegmentControl = styled.div`
  margin-top: 12px;
  padding: 0 12px 12px 12px;
`

export const Spin = styled(SpinAnt)`
  margin-top: 16px;
`
